import React, {RefObject} from 'react';

interface IProgressProps {
  playingTime: number;
  totalDuration: number;
  progressRef: RefObject<HTMLDivElement>;
  thumbnailRef: RefObject<HTMLDivElement>;
  progressMove: {
    time: string;
    position: number;
    top: number;
    left: number;
  };
}

/**
 * 재생 바 컴포넌트
 */
const Progress = ({progressRef}: IProgressProps) => {
  return <div className='progress' ref={progressRef}></div>;
};

export default Progress;
